import {Component, Input, OnInit} from '@angular/core';
import {ChangeRequestVO} from '../../../generate/TldChangeResultVO';

@Component({
    selector: 'changes-requested-block',
    templateUrl: './changes-requested-block.component.html',
    styleUrls: ['./changes-requested-block.component.scss'],
    standalone: false
})
export class ChangesRequestedBlockComponent implements OnInit {

  @Input()
  changeRequestVO: ChangeRequestVO;

  constructor() { }

  ngOnInit() {
  }

}
